import React from 'react';
import styled from 'styled-components';
import nitoLogo from '../../assets/cnito_logo_black.svg';
import starBackgroundTablet from '../../assets/star_background_tablet.png';
import arrow from '../../assets/arrow.svg';

const matches = window.location.origin.match(/cartoonnetwork([.][^\/]+)/g);

let cnitoURL;
if (matches && matches.length > 0) {
    cnitoURL = matches[0].replace('cartoonnetwork', 'https://cartoonito');
} else {
    cnitoURL = 'https://cartoonito.com.br/';
}

export const CartoonitoLink = props => {
    return (
        <Container href={cnitoURL} target="_blank" rel="noopener noreferrer">
            <Logo src={nitoLogo} alt="Nito" />
            <Arrow src={arrow} />
        </Container>
    );
};

const Logo = styled.img`
    width: 138px;
    height: 30px;
    margin-left: 14px;
    margin-bottom: 0px;
`;

const Arrow = styled.img`
    width: 10px;
    margin-right: 18px;
`;

const Container = styled.a`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    min-width: 200px;
    min-height: 44px;
    box-sizing: border-box;
    background: rgb(246, 215, 5);
    background-position: 0px 34px;
    background-size: 200%;
    border-radius: 6.29px;
    border: none;
    padding: 8px 0px;

    color: rgb(0, 0, 0);
    font-size: 16px;
    font-family: 'Rodger';
    font-weight: 900;
    text-align: center;
    text-transform: uppercase;
    line-height: 24px;
    text-decoration: none;
`;
